import { whatsappapi } from "../api/api";
export function SendMessageDocs() {
    return (
      <div>
        <h2 className="fw-bold">Send Message</h2>
        <p className="text-muted">Send a text message to a specific WhatsApp number using an active device.</p>
        
        <div className="badge bg-success-subtle text-success mb-3 px-3 py-2">POST</div>
        <code className="d-block bg-light p-3 rounded-3 mb-4 text-dark">
          https://{whatsappapi}/v1/messages/send
        </code>
  
        <h5 className="fw-bold mt-4">Request Body</h5>
        <table className="table table-bordered rounded-3 overflow-hidden mt-3">
          <thead className="bg-light">
            <tr>
              <th>Parameter</th>
              <th>Type</th>
              <th>Description</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td><code className="text-danger">device_id</code></td>
              <td>String</td>
              <td>The unique ID of your connected WhatsApp instance.</td>
            </tr>
            <tr>
              <td><code className="text-danger">to</code></td>
              <td>String</td>
              <td>Recipient number with country code (e.g. 15550123).</td>
            </tr>
            <tr>
              <td><code className="text-danger">msg</code></td>
              <td>String</td>
              <td>The content of the message.</td>
            </tr>
          </tbody>
        </table>
  
        <h5 className="fw-bold mt-5">Example Request</h5>
        <div className="bg-dark text-white p-4 rounded-4 position-relative">
          <pre className="mb-0" style={{ fontSize: '0.9rem', color: '#a6accd' }}>
  {`curl -X POST https://{whatsappapi}/v1/messages/send \\
  -H "Authorization: Bearer YOUR_API_KEY" \\
  -d "device_id=102" \\
  -d "to=15550123" \\
  -d "msg=Hello from the API!"`}
          </pre>
          <button className="btn btn-sm btn-outline-light position-absolute top-0 end-0 m-3 opacity-50">Copy</button>
        </div>
      </div>
    );
  }